import { type Editor } from '@tiptap/react'
import { GlobalInputSettings } from '../components'

export const ShortAnswerSettings = ({
	pos,
	node,
	editor,
}: {
	pos: number
	node: any
	editor: Editor
}) => {
	return (
		<div className="flex flex-col gap-2">
			<GlobalInputSettings
				node={node}
				setRequired={(e: any) => {
					editor
						.chain()
						.setNodeSelection(pos)
						.setShortAnswerRequired(String(e) === 'true')
						.run()
				}}
				setConnect={(value: string) => {
					editor.chain().setNodeSelection(pos).setShortAnswerTo(value).run()
				}}
				setRegex={(value: string) => {
					editor.chain().setNodeSelection(pos).setShortAnswerRegex(value).run()
				}}
				setUnique={(value: boolean) => {
					editor.chain().setNodeSelection(pos).setShortAnswerUnique(value).run()
				}}
				canBeUnique={true}
				canChangeRegex={true}
			/>
		</div>
	)
}

export default ShortAnswerSettings
